import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-304c986e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-nowrap flex items-center" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = {
  key: 3,
  class: "flex items-center flex-nowrap ml-[8px]"
}
const _hoisted_4 = {
  key: 0,
  class: "flex items-center flex-nowrap mt-[8px]"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "text-System/app_error uis uis-exclamation-circle" }, null, -1))
const _hoisted_6 = { class: "text-System/app_error text-[12px] ml-[8px]" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediField, IncrediSelect } from 'incredi-ui';
import { MAP_COLUMNS_To_Key_Roles, MAP_Key_Roles_To_Show } from '@/views/settings/settingsApiAccess/settingsApiAccess.const';
import ManageGroupsSelectMenu from '@/components/common/dialogs/settingsActiveDirectoryDialog/manageSecurityGroupsDialog/manageGroupsSelectMenu/manageGroupsSelectMenu.vue';
import { Key_Role } from '@/graphql/codegen/gql/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'securityGroupRow',
  props: {
    options: null,
    group: null,
    role: null,
    isSingleAdmin: { type: Boolean },
    errorMessage: { default: '' },
    disabled: { type: [Boolean, null], default: false },
    manualInsert: { type: Boolean, default: false }
  },
  emits: ["deleteRow", "onGroupSelection", "onRoleSelection"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'deleteRow'): void;
  (e: 'onGroupSelection', value: string): void;
  (e: 'onRoleSelection', value: keyof typeof MAP_COLUMNS_To_Key_Roles): void;
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full my-[8px] py-[8px] px-[8px]", [__props.isSingleAdmin ? 'justify-start' : 'justify-between', __props.errorMessage ? 'bg-System/app_error_bg' : 'bg-System/app_grey_95']])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.manualInsert)
            ? (_openBlock(), _createBlock(_unref(IncrediField), {
                key: 0,
                "model-value": __props.group as any,
                name: "group",
                size: "tiny",
                label: "",
                style: {"width":"176px"},
                onChange: _cache[0] || (_cache[0] = ($event) => emit('onGroupSelection', $event))
              }, null, 8, ["model-value"]))
            : (_openBlock(), _createBlock(ManageGroupsSelectMenu, {
                key: 1,
                "model-value": __props.group as any,
                class: _normalizeClass(["group-role-select w-[176px]", {
            'bg-white': !__props.disabled,
          }]),
                searchable: "",
                options: __props.options,
                size: "tiny",
                direction: "bottom-sticky-left",
                label: "Select a group name",
                disabled: __props.disabled || false,
                "max-height": 200,
                "min-width": 176,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => emit('onGroupSelection', $event))
              }, null, 8, ["model-value", "class", "options", "disabled"])),
          (__props.isSingleAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass([__props.disabled ? 'text-Text/text_lowest' : 'text-Text/text_high', "text-[12px] pl-[20px]"])
                }, _toDisplayString(_unref(MAP_Key_Roles_To_Show)[_unref(Key_Role).GridAdmin as keyof typeof MAP_Key_Roles_To_Show]), 3)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(IncrediSelect), {
                  class: _normalizeClass(["group-role-select w-[144px]", {
              'bg-white': !__props.disabled,
            }]),
                  disabled: __props.disabled || false,
                  "model-value": __props.role as string,
                  items: Object.values(_unref(MAP_Key_Roles_To_Show)),
                  size: "tiny",
                  direction: "bottom-sticky-left",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => { emit('onRoleSelection', $event)})
                }, null, 8, ["class", "disabled", "model-value", "items"]),
                _createElementVNode("div", {
                  class: _normalizeClass([__props.disabled ? 'pointer-events-none' : '', "hover:bg-Hovers/hover_grey hover:border-[2px] w-[36px] h-[36px] ml-[4px] flex justify-center items-center cursor-pointer"]),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('deleteRow')), ["prevent"]))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["uil uil-trash !text-[20px]", __props.errorMessage ? 'text-System/app_error' : 'text-Text/text_medium'])
                  }, null, 2)
                ], 2)
              ]))
        ]),
        (__props.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(__props.errorMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}
}

})